import React from 'react';
import { ShieldCheck, Mail, Calendar, Clock, UserCircle2, Image as ImageIcon } from 'lucide-react';
import { adminUsuariosAPI } from '../../utils/adminUsuariosAPI';
import ModalRodape from './ModalRodape';

const BADGE_TIPO = {
  admin: 'bg-indigo-100 text-indigo-700',
  gerenciador: 'bg-blue-50 text-blue-700'
};

const linha = (Icone, texto) => (
  <div className="flex items-center gap-2 text-sm text-gray-600">
    <Icone className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" /> {texto}
  </div>
);

// Só leitura — nenhum controle de edição aqui (isso é escopo do
// EditarUsuarioModal). Ver detalhes existe pra ver, e só.
const DetalhesUsuarioModal = ({ usuario, usuarios, onFechar }) => {
  const criador = usuario.criado_por ? usuarios.find((u) => u.id === usuario.criado_por) : null;

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-4">
        <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 text-xl font-semibold overflow-hidden flex-shrink-0">
          {usuario.foto ? (
            <img src={adminUsuariosAPI.fotoUrl(usuario.id)} alt="" className="w-full h-full object-cover" />
          ) : (
            usuario.nome_completo?.[0]?.toUpperCase() || '?'
          )}
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 truncate">{usuario.nome_completo}</p>
          <div className="flex items-center gap-1.5 flex-wrap mt-1">
            <span className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${BADGE_TIPO[usuario.tipo]}`}>
              {usuario.tipo === 'admin' && <ShieldCheck className="w-3 h-3" />} {usuario.tipo}
            </span>
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${usuario.ativo ? 'bg-emerald-50 text-emerald-700' : 'bg-gray-100 text-gray-500'}`}>
              {usuario.ativo ? 'ativo' : 'desativado'}
            </span>
          </div>
        </div>
      </div>

      <div className="space-y-2.5 border-t border-gray-100 pt-4">
        {linha(Mail, usuario.email)}
        {linha(Calendar, `Criado em ${new Date(usuario.data_criacao).toLocaleDateString('pt-BR')}`)}
        {usuario.ultimo_acesso && linha(Clock, `Último acesso em ${new Date(usuario.ultimo_acesso).toLocaleString('pt-BR')}`)}
        {criador && linha(UserCircle2, `Criado por ${criador.nome_completo}`)}
        {usuario.meta && linha(
          ImageIcon,
          `Foto: ${(usuario.meta.tamanho / 1024).toFixed(0)} KB · ${usuario.meta.formato?.toUpperCase() || ''}`
        )}
      </div>

      <ModalRodape>
        <button
          onClick={onFechar}
          className="text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg px-4 py-2.5 transition-colors"
        >
          Fechar
        </button>
      </ModalRodape>
    </div>
  );
};

export default DetalhesUsuarioModal;
